import { mapToCanActivate, Routes } from '@angular/router';

import { coreRoutes } from '@next/core-lib/app';
import { LocationGuard } from '@next/core-lib/relationships';

import { OverviewComponent } from './overview/overview.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/overview',
    pathMatch: 'full',
  },
  {
    path: 'overview',
    component: OverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
  },
  ...coreRoutes,
];
